var _rect, _rect2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMagicWandActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 5,
    fill: "#EBF2F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    transform: "translate(3 3)",
    fill: "#EBF2F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1151 8.5393C13.101 8.47928 13.0723 8.42366 13.0316 8.37736C12.9909 8.33107 12.9394 8.29552 12.8817 8.27387L10.1803 7.26084L10.8677 3.82353C10.8837 3.74353 10.8732 3.66049 10.8377 3.58701C10.8023 3.51353 10.7438 3.45362 10.6712 3.41637C10.5986 3.37912 10.5159 3.36656 10.4355 3.38059C10.3551 3.39462 10.2815 3.43448 10.2259 3.49413L4.97586 9.11913C4.93379 9.1642 4.90348 9.21895 4.88762 9.27852C4.87176 9.3381 4.87083 9.40067 4.88492 9.46069C4.89901 9.52071 4.92768 9.57634 4.96839 9.62263C5.00911 9.66893 5.06061 9.70448 5.11834 9.72612L7.81976 10.7392L7.13229 14.1765C7.11628 14.2565 7.12681 14.3395 7.16227 14.413C7.19773 14.4865 7.25619 14.5464 7.32878 14.5836C7.40138 14.6209 7.48414 14.6335 7.56452 14.6194C7.64489 14.6054 7.7185 14.5655 7.77417 14.5059L13.0242 8.88086C13.0662 8.83579 13.0965 8.78104 13.1124 8.72147C13.1283 8.66189 13.1292 8.59932 13.1151 8.5393V8.5393Z",
    fill: "#3B82C9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWandActive);
export default __webpack_public_path__ + "static/media/magic_wand_active.6d032124.svg";
export { ForwardRef as ReactComponent };